/**
 * Format without symbols(', ", [, ])
 */
function formatWithoutSymbols(stringData: string): string {
    return stringData
        .replace('[', '')
        .replace(']', '')
        .replace(/'|"/g, '')
        .replace(/,/g, '\n');
}
export default formatWithoutSymbols;
